import React from 'react'
import { DisclaimerOnlineMessage } from './DisclaimerOnlineSaleMessage'
import { DisclaimerMessage } from './DisclaimerMessage'
import OnlineSaleCommissionMessage from '../../OnlineSaleCommissionMessage'
import { enableElo } from '../../../../utils/enable-elo'

export default {
  commission: null,
  disclaimer: () => <DisclaimerMessage />,
  disclaimerOnline: (isB2C) => <DisclaimerOnlineMessage isB2C={isB2C} />
}
